import React from "react";

import { faEllipsisV } from "@fortawesome/pro-regular-svg-icons/faEllipsisV";
import { faEllipsisH } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip, { TooltipProps } from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { Button, ButtonProps } from "@mapmycustomers/ui";

interface Props extends ButtonProps {
  horizontal?: boolean;
  tooltipProps?: TooltipProps;
}

const MoreButton = ({
  className,
  horizontal = false,
  size,
  tooltipProps,
  type = "text",
  ...props
}: Props) => {
  const intl = useIntl();

  return (
    <Tooltip
      title={intl.formatMessage({
        id: "moreButton.openMenu",
        defaultMessage: "Open menu",
        description: "Tooltip for open menu button",
      })}
      {...tooltipProps}
    >
      <Button
        className={className}
        iconOnly
        size={size}
        type={type}
        {...props}
        icon={<FontAwesomeIcon icon={horizontal ? faEllipsisH : faEllipsisV} />}
      />
    </Tooltip>
  );
};

export default MoreButton;
